








































































import Vue from 'vue'
import firebase from 'firebase/app'
import 'firebase/firestore'
import showdown from 'showdown'
import Payment from './Payment.vue'
import * as Interface from '../../functions/interfaces'


export default Vue.extend({
    components: { Payment },


    mounted() {
        this.fetch()
    },
    

    data() {
        return {
            project: {
                name: {},
                description: {},
                currency: undefined
            },

            result: undefined as Interface.Pledge | undefined
        }
    },


    computed: {
        description() {
            if (this.project.description == null) return ''
            const converter = new showdown.Converter()
            const translated = this.$tt(this.project.description)
            let html = converter.makeHtml(translated)
            if (html != null)
                html = html.replace(/<p>/g, '<p style="margin: 0 0 2rem 0">')
            return html
        },

        resultStatus() {
            let status = {
                title: '',
                comment: null,
                state: 'inprogress'
            }
            if (this.result?.status == 'SUCCESS' || this.result?.status == 'STARTED' /*dummy status*/)
                status.title = this.$t('status_in_progress')
                status.comment = this.$t('might_take_some_time')
            if (this.result?.status == 'FINISHED') {
                status.title = this.$t('status_thank_you') + ' 🎉'
                status.state = 'success'
                status.comment = this.$t('contributed')}
            if (this.result?.status == 'FAIL') {
                status.title = this.$t('status_failed')
                status.comment = this.$t('comment_failed')
                status.state = 'fail'}
            if (this.result?.status == 'CANCEL') {
                status.title = this.$t('status_cancelled')
                status.comment = this.$t('comment_cancelled')
                status.state = 'fail'}
            if (this.result?.status == 'TIMEOUT') {
                status.title = this.$t('status_timeout')
                status.comment = this.$t('comment_timeout')
                status.state = 'fail'}
            return status
        }


    },


    methods: {
        fetch: async function() {
            const alias = this.$route.params.alias
            
            firebase.firestore().collection('projects').where('aliases', 'array-contains', alias).onSnapshot((snap) => {
                const doc = snap.docs[0]
                const project = doc.data()!
                project.id = doc.id
                project.target = project.target.toString()
                Object.assign(this.project, project)
            })
        },


        showResult(pledge: Interface.Pledge) {
            this.result = pledge
        }
    }
})
